module.exports = __webpack_public_path__ + "static/media/LoginIn.7a18bfed.svg";